/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Tab_OverviewInputs */

const en_ui_studio_tab_overview = /** @type {(inputs: Ui_Studio_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const de_ui_studio_tab_overview = /** @type {(inputs: Ui_Studio_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Ui_Studio_Tab_OverviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_tab_overview = /** @type {((inputs?: Ui_Studio_Tab_OverviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Tab_OverviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_tab_overview(inputs)
	return de_ui_studio_tab_overview(inputs)
});